<template>
  <div class="app">
    <!-- <img src="./assets/bg.jpg" alt="" class="bg" /> -->

    <div class="IM">
      <div class="header">
        <img src="../../assets/logo.png" alt="" class="logo" />
        <div>河北传媒学院在线咨询</div>

        <div v-if="userInfo" class="user-info">
          <div class="phone">{{ maskedPhone }}</div>
          <div @click="handleLogout" class="logout">退出咨询</div>
        </div>
      </div>
      <div class="body">
        <div class="main">
          <div ref="msgList" class="msg-list">
            <span
              v-if="userInfo && hasMore"
              @click="getOldMsgList"
              class="view-more"
            >
              查看更多历史消息
            </span>

            <div class="wait">
              同学您好，欢迎报考河北传媒学院。咨询请留言...
            </div>

            <div
              v-for="msg in sortedMsgList"
              :key="msg.MessageID"
              class="msg"
              :class="msg.UserSend ? 'right' : 'left'"
            >
              <div v-if="msg.MessageType != 3 || msg.faq" class="top">
                {{ msg.UserSend ? maskedPhone : "在线咨询" }}&nbsp;&nbsp;
                {{ formatTime(msg.CreatedTime * 1000) }}
              </div>
              <div v-if="msg.MessageType == 1" class="content">
                {{ msg.Content }}
              </div>
              <div v-if="msg.MessageType == 3 && msg.faq" class="content">
                <div class="msg-faq">
                  <div class="head">
                    <div class="label">常见问题</div>
                    <div class="title">{{ msg.faq.questionTitle }}</div>
                  </div>
                  <div class="msg-solution">
                    <template v-for="s in sortSolutions(msg.faq.solutions)">
                      <div
                        class="solution"
                        :key="s.sort"
                        v-if="s.contentType == 0"
                      >
                        {{ s.solutionContent }}
                      </div>

                      <el-image
                        class="s-img solution"
                        :key="s.sort"
                        v-else
                        :src="s.solutionContent"
                        :preview-src-list="[s.solutionContent]"
                      ></el-image>
                    </template>
                  </div>
                </div>
              </div>
            </div>

            <div ref="bottom"></div>
          </div>
          <div class="sender">
            <el-input
              class="input"
              type="textarea"
              autosize
              placeholder="请输入内容"
              v-model="msgContent"
              @keyup.enter.native="handleSendMessage"
            >
            </el-input>
            <button
              @click="handleSendMessage"
              class="btn-send"
              :class="{ disabled: !msgContent }"
              :disabled="!msgContent"
            >
              发送
            </button>

            <div v-if="!userInfo" class="login-mask">
              <div>
                请<span @click="loginVisible = true" class="btn-login"
                  >登录</span
                >后进行咨询
              </div>
            </div>
          </div>
        </div>
        <div class="faq">
          <div class="faq-title">常见问题</div>

          <el-collapse v-model="activeNames">
            <el-collapse-item
              v-for="faq in faqList"
              :key="faq.questionId"
              :title="faq.questionTitle"
              :name="faq.questionId"
            >
              <template v-for="s in sortSolutions(faq.solutions)">
                <div class="solution" :key="s.sort" v-if="s.contentType == 0">
                  {{ s.solutionContent }}
                </div>

                <el-image
                  class="s-img solution"
                  :key="s.sort"
                  v-else
                  :src="s.solutionContent"
                  :preview-src-list="[s.solutionContent]"
                ></el-image>
              </template>
            </el-collapse-item>
          </el-collapse>
        </div>
      </div>
    </div>

    <el-dialog
      center
      :show-close="false"
      title="登录"
      :visible.sync="loginVisible"
      class="login-dialog"
    >
      <div class="login-wrapper">
        <div class="login-input">
          <el-input v-model="phone" placeholder="请输入手机号"></el-input>
        </div>

        <div class="login-input auth-wrapper">
          <el-input
            style="margin-top: 20px"
            v-model="authCode"
            placeholder="请输入验证码"
            maxlength="10"
          >
          </el-input>
          <el-button v-if="time" class="btn-auth" type="text">
            {{ time }}秒
          </el-button>
          <el-button
            v-else
            :disabled="disabled"
            @click="sendCode"
            class="btn-auth"
            type="text"
          >
            发送验证码
          </el-button>
        </div>

        <div class="btn-login" @click="handleLogin">登录</div>

        <!-- <div class="tip">
          登录即表示同意<el-button class="privacy" type="text"
            >《隐私协议》
          </el-button>
        </div> -->
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { getAuthCode, login, getFaqList } from "../../services/user";
import { getMessageList, sendMessage } from "../../services/message";
import {
  setUserInfo,
  getUserInfo,
  setClientId,
  getClientId,
  getUuid,
} from "../../utils/common";
import dayjs from "dayjs";

export default {
  name: "App",
  components: {},
  data() {
    return {
      loginVisible: false,
      msgContent: "",
      activeNames: ["1"],
      phone: "",
      authCode: "",
      codeTimer: null,
      time: null,
      disabled: false,
      userInfo: null,
      ClientID: null,
      institutionId: "",

      messageList: [],
      faqList: [],
      hasMore: true,

      msgFetchTimer: null,

      currentImage: null,
      imgPreviewVisible: false,
    };
  },
  computed: {
    sortedMsgList() {
      const result = this.messageList.sort((a, b) => {
        return a.Sequence - b.Sequence;
      });

      result.forEach((item) => {
        if (item.MessageType === 3) {
          try {
            const question = JSON.parse(atob(item.Content));
            const id = question.extra.businessId;
            if (typeof id === "string") {
              const faq = this.faqList.find((i) => i.questionId == id);
              item.faq = faq;
            }
          } catch (error) {}
        }
      });

      return result;
    },
    maxSequence() {
      return (
        this.sortedMsgList.length > 0 &&
        this.sortedMsgList[this.sortedMsgList.length - 1].Sequence
      );
    },
    minSequence() {
      return this.sortedMsgList.length > 0 && this.sortedMsgList[0].Sequence;
    },
    maskedPhone() {
      if (!this.userInfo) {
        return null;
      } else {
        const phone = this.userInfo.phoneNumber;
        const a1 = phone.slice(0, 3);
        const a2 = phone.slice(9, 11);
        const mask = a1 + "******" + a2;
        return mask;
      }
    },
    userId() {
      if (!this.userInfo) {
        return null;
      } else {
        return this.userInfo.userId;
      }
    },
  },
  async created() {
    this.institutionId = this.$route.query.institutionId;
    await this.getFaqList();
    const userinfo = getUserInfo();
    this.userInfo = userinfo;
    const ClientID = getClientId();
    this.ClientID = ClientID;
    if (this.userInfo) {
      await this.getOldMsgList();
      this.scrollToBottom();
      this.setMsgFetchTimer();
    }
    window.vm = this;
  },
  methods: {
    previewImage(url) {
      this.currentImage = url;
      this.imgPreviewVisible = true;
    },

    async setMsgFetchTimer() {
      this.clearMsgFetchTimer();
      this.msgFetchTimer = setInterval(async () => {
        await this.getNewMsgList();
      }, 60000);
    },

    clearMsgFetchTimer() {
      clearInterval(this.msgFetchTimer);
      this.msgFetchTimer = null;
    },

    async getFaqList() {
      const res = await getFaqList(this.institutionId);
      this.faqList = res;
    },
    handleLogout() {
      this.$confirm("您确定要退出咨询吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
        customClass: "logout-confirm-dialog",
      })
        .then(() => {
          this.userInfo = null;
          window.localStorage.clear();
          window.location.reload();
        })
        .catch(() => {});
    },
    formatTime(time) {
      return dayjs(time).format("YYYY-MM-DD HH:mm:ss");
    },
    // 获取历史消息
    async getOldMsgList() {
      const params = {
        clientId: this.ClientID,
        direction: 0,
        sequence: this.minSequence || 999999,
        num: 20,
      };
      const res = await getMessageList(this.userId, this.institutionId, params);
      const { Count, Messages } = res;
      if (Messages) {
        this.messageList = [...this.messageList, ...Messages];
      }
      if (Count < 20) {
        this.hasMore = false;
      }
    },

    // 获取新消息
    async getNewMsgList() {
      const params = {
        clientId: this.ClientID,
        direction: 0,
        sequence: 99999,
        num: 20,
      };
      const res = await getMessageList(this.userId, this.institutionId, params);
      const { Count, Messages } = res;

      const existIds = this.sortedMsgList.map((i) => i.Sequence);

      const newMessages =
        Messages && Messages.filter((i) => !existIds.includes(i.Sequence));
      if (newMessages) {
        this.messageList = [...this.messageList, ...newMessages];
      }
      if (Count < 20) {
        this.hasMore = false;
      }
    },

    scrollToBottom() {
      this.$nextTick(() => {
        const bottom = this.$refs.bottom;
        if (bottom) {
          bottom.scrollIntoView();
        }
      });

      // setTimeout(() => {
      //   const msgListDOM = this.$refs.msgList;
      //   msgListDOM.scrollTop = msgListDOM.scrollHeight;
      // }, 200);
    },

    async handleSendMessage() {
      const msgContent = this.msgContent;
      if (msgContent.trim().length <= 0) {
        return;
      }
      this.msgContent = "";
      const base64info = btoa(
        JSON.stringify({ phone: this.userInfo.phoneNumber })
      );

      const body = {
        ClientID: this.ClientID,
        Content: msgContent,
        InstSenderID: this.userId,
        MessageID: getUuid(),
        MessageType: 1,
        UserInfo: base64info,
      };
      await sendMessage(this.userId, this.institutionId, body);
      await this.getNewMsgList();
      this.scrollToBottom();
    },
    async handleLogin() {
      if (!this.phone) {
        this.$message.error("请输入手机号");
        return;
      }
      if (!this.authCode) {
        this.$message.error("请输入验证码");
        return;
      }
      // const res = await oldLogin(this.phone, this.authCode);
      const res = await login(this.phone, this.authCode);

      this.$message.success("登录成功");
      this.userInfo = res;
      setUserInfo(res);
      setClientId();
      this.ClientID = getClientId();
      this.loginVisible = false;
      this.getOldMsgList();
      this.setMsgFetchTimer();
    },

    async sendCode() {
      this.disabled = true;
      try {
        const res = await getAuthCode(this.phone);
        this.setUpCodeTimer();
        this.$message.success("发送成功");
      } catch (error) {
      } finally {
        this.disabled = false;
      }
    },

    sortSolutions(list) {
      const copy = [...list];
      return copy.sort((a, b) => {
        return a.sort - b.sort;
      });
    },

    setUpCodeTimer() {
      this.time = 60;
      this.codeTimer = setInterval(() => {
        this.time--;
        if (this.time <= 0) {
          this.clearCodeTimer();
        }
      }, 1000);
    },

    clearCodeTimer() {
      clearInterval(this.codeTimer);
      this.time = null;
      this.codeTimer = null;
    },
  },
};
</script>
 
<style lang="scss" scoped>
.auth-wrapper {
  position: relative;
  .btn-auth {
    position: absolute;
    width: 110px;
    box-sizing: border-box;
    right: 0;
    bottom: 0;
    padding-left: 19px;
    padding-right: 19px;
    &::before {
      height: 20px;
      position: absolute;
      content: "";
      border-left: 1px solid #cccccc;
      left: 0;
      top: 10px;
    }
  }
}

.login-dialog /deep/ .el-dialog {
  width: 440px;
}

.login-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;

  .tip {
    margin-top: 10px;
    font-size: 12px;
    color: #999999;
    .privacy {
      font-size: 12px;
    }
  }

  .login-input {
    width: 340px;
    margin: 0 auto;
  }

  .btn-login {
    width: 340px;
    height: 49px;
    background: #700005;
    opacity: 1;
    border-radius: 8px;
    margin-top: 32px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #ddd;
    cursor: pointer;
  }
}

.app {
  width: 100%;
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  background: url("../../assets/bg.png");
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  .bg {
    position: absolute;
    z-index: -1;
    opacity: 0.5;
    left: 0;
    top: 0;
    right: 0;
    bottom: 0;
    object-fit: cover;
    height: 100vh;
    max-width: 100%;
  }
}

.img-preview {
  width: 100%;
}

.IM {
  // opacity: 0.8;
  overflow: hidden;
  width: 992px;
  height: 760px;
  box-sizing: border-box;
  border-radius: 8px;
  display: flex;
  flex-direction: column;

  .header {
    background: #700005;
    height: 72px;
    display: flex;
    align-items: center;
    color: #fff;
    .logo {
      height: 36px;
      width: 36px;
      margin-left: 26px;
      margin-right: 18px;
    }

    .user-info {
      margin-right: 24px;
      height: 32px;
      display: flex;
      margin-left: auto;
      border: 1px solid #b37578;
      text-align: center;
      border-radius: 4px;
      align-items: center;

      .phone {
        width: 130px;
        border-right: 1px solid #b37578;
        color: #b37578;
      }
      .logout {
        color: #ccc;
        cursor: pointer;
        width: 103px;
      }
    }
  }

  .body {
    display: flex;
    flex: 1;
    overflow: hidden;

    .main {
      flex: 1;
    }

    .faq {
      overflow: auto;
      box-sizing: border-box;
      padding: 17px 10px 17px;
      width: 272px;
      border-left: 1px solid #e5e5e5;
      background: #f8f8f8;
      .faq-title {
        font-size: 18px;
        color: rgba(0, 0, 0, 0.56);
      }
      .s-img {
        max-width: 100%;
      }
      .solution {
        margin: 3px 0;
      }

      /deep/ .el-collapse-item__header {
        display: block;
        color: rgba(0, 0, 0, 0.56);
        overflow: hidden; //超出的文本隐藏
        text-overflow: ellipsis; //溢出用省略号显示
        word-break: break-all;
        white-space: nowrap;
        position: relative;
        padding-right: 30px;
        line-height: unset;
        padding: 18px 0;
        height: unset;
        .el-collapse-item__arrow {
          position: absolute;
          right: 0;
          top: 20px;
        }
      }
      /deep/ .el-collapse-item__header.is-active {
        padding-right: 0;
        color: #92191e;
        display: flex;
        white-space: unset;

        .el-collapse-item__arrow {
          position: unset;
        }
      }

      /deep/ .el-collapse {
        background: #f8f8f8;
      }
      /deep/ .el-collapse-item__header {
        background: #f8f8f8;
      }

      /deep/ .el-collapse-item__wrap {
        background: #f8f8f8;
      }
    }
  }
}

.main {
  display: flex;
  flex-direction: column;
}

.msg-list {
  .wait {
    background: #ccc;
    font-size: 14px;
    padding: 10px;
    color: #fff;
    text-align: center;
    margin: 10px;
  }

  flex: 1;
  overflow: auto;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.8);
  padding: 24px;
  display: flex;
  flex-direction: column;
  .view-more {
    color: rgba(0, 0, 0, 0.32);
    font-size: 14px;
    text-align: center;
    cursor: pointer;
    display: block;
    margin: 0 auto;
  }

  .msg {
    font-size: 14px;
    margin: 10px 0;
    max-width: 90%;
    // display: flex;
    // flex-direction: column;

    .top {
      color: rgba(0, 0, 0, 0.32);
      margin: 5px;
    }
    .content {
      padding: 8px 16px;
      border-radius: 8px;
      line-height: 22px;
      word-break: break-all;
      display: inline-block;

      .msg-faq {
        margin-top: 5px;
        .head {
          display: flex;
          align-items: center;
          .label {
            white-space: nowrap;
            font-size: 12px;
            text-align: center;
            width: 56px;
            height: 20px;
            line-height: 20px;
            color: #92191e;
            border: 1px solid #92191e;
            border-radius: 2px;
            margin-right: 10px;
          }
          .title {
            flex: 1;
          }
        }
        .msg-solution {
          display: flex;
          flex-direction: column;

          .solution {
            margin-top: 5px;
          }
          .s-img {
            max-width: 60%;
            margin: 0 auto;
          }
        }
      }
    }

    &.right {
      margin-left: auto;
      .top {
        text-align: right;
      }
      .content {
        float: right;
        background: #404961;
        color: #fff;
      }
    }

    &.left {
      .top {
        text-align: left;
      }
      .content {
        float: left;
        background: #fff;
        color: #000;
      }
    }
  }
}

.sender {
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.23);
  height: 142px;
  box-sizing: border-box;
  border-top: 1px solid #e5e5e5;
  position: relative;

  .login-mask {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    top: 0;
    z-index: 10;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 18px;
    color: #ffffff;
    .btn-login {
      color: #ffeb00;
      margin: 5px;
      text-decoration: underline;
      cursor: pointer;
    }
  }

  .input {
    overflow: auto;
    height: 100%;
    /deep/ .el-textarea__inner {
      border: none;
      height: 100% !important;
      resize: none;
      border-radius: 0;
    }
  }

  .btn-send {
    outline: none;
    border: none;
    position: absolute;
    cursor: pointer;
    width: 80px;
    height: 32px;
    background: #8f000b;
    opacity: 1;
    border-radius: 4px;
    text-align: center;
    line-height: 32px;
    color: #fff;
    bottom: 16px;
    right: 24px;
    &.disabled {
      cursor: not-allowed;
      opacity: 0.4;
    }
  }
}

@media (max-width: 1600px) {
  .IM {
    width: 848px;
    height: 650px;

    .header {
      height: 60px;
    }

    .faq {
      width: 240px !important;
    }
  }
}

@media (max-width: 1300px) {
  .IM {
    width: 750px;
    height: 550px;

    .header {
      height: 55px;
    }

    .faq {
      width: 220px !important;
    }
  }
}

@media only screen and (max-width: 600px) {
  .logout-confirm-dialog {
    width: 95%;
  }

  .app {
    width: 100%;
    position: relative;
    height: unset;
    min-height: 100vh;
  }

  .login-dialog /deep/ .el-dialog {
    width: 90%;
  }

  .login-wrapper {
    .login-input {
      width: 90%;
    }

    .btn-login {
      width: 90%;
    }
  }

  .IM {
    width: 95%;
    height: unset;
    .header {
      height: 50px;
      font-size: 13px;
      .logo {
        height: 25px;
        width: 25px;
        margin-left: 10px;
        margin-right: 10px;
      }

      .user-info {
        margin-right: 10px;
        height: 26px;

        .phone {
          white-space: nowrap;
          width: unset;
          padding: 0 10px;
        }
        .logout {
          white-space: nowrap;
          padding: 0 10px;
          width: unset;
        }
      }
    }

    .msg-list {
      min-height: 250px;
      max-height: 250px;
      .wait {
        font-size: 12px;
        padding: 10px;
        text-align: center;
        margin: 10px;
      }

      padding: 15px;
    }

    .body {
      flex-direction: column;

      .sender {
        height: 120px;
      }

      .faq {
        // display: none;
        width: 100% !important;
        max-height: 150px;
        overflow: auto;
        .s-img {
          width: 50%;
        }
      }
    }
  }
}
</style>      

<style>
@media only screen and (max-width: 600px) {
  .logout-confirm-dialog {
    width: 95%;
  }
}
</style>